import { FILTER_KEYS } from '@app/consts';

/**
 * Transform bracket-notation query params (e.g., param[0], param[1]) into arrays
 * This function modifies the query object in-place to convert bracket notation to arrays
 *
 * @example
 * const query = {
 *   id: '123',
 *   'reservationFeatures[0]': 'freeCancellation',
 *   'reservationFeatures[1]': 'withoutPrepayment'
 * };
 *
 * const result = preprocessQueryParams(query);
 * // { id: '123', reservationFeatures: ['freeCancellation', 'withoutPrepayment'] }
 */
export const preprocessQueryParams = (query: Record<string, any>): Record<string, any> => {
    const arrayParams = [
        FILTER_KEYS.PROPERTY_TYPE,
        FILTER_KEYS.AMENITIES,
        FILTER_KEYS.PROVISION,
        FILTER_KEYS.RESERVATION_FEATURES,
    ];
    const result = { ...query };

    arrayParams.forEach(paramName => {
        const bracketKeys = Object.keys(result).filter(
            k => k.startsWith(`${paramName}[`) && k.endsWith(']'),
        );

        if (bracketKeys.length > 0) {
            const values = bracketKeys
                .map(k => {
                    const match = k.match(/\[(\d+)\]/);
                    const index = match ? parseInt(match[1], 10) : 0;
                    return { index, value: result[k] };
                })
                .sort((a, b) => a.index - b.index)
                .map(item => item.value);

            result[paramName] = values;
            bracketKeys.forEach(k => delete result[k]);
        }
    });

    return result;
};
